/* eslint-disable @typescript-eslint/ban-ts-comment */
import { ComponentType, Suspense, lazy, useEffect, useMemo, useState } from 'react';

import Skeleton from 'components/Skeleton';

function Loader() {
  return <div />;
}

function AsyncLoader<Props>(
  componentLoader: () => Promise<{ default: ComponentType<Props> }>,
  Fallback: any = Loader,
  delay = 200,
  height = null,
) {
  const DeferredComponentWrapper = (props: Props) => {
    const [state, setState] = useState(() => performance.now());
    const DeferredComponent = useMemo(() => lazy(componentLoader), []);
    const actualResult = (
      <Suspense fallback={<Skeleton height={height} />}>
        {/* @ts-ignore for the issue connected with PropsWithRef<PropsWithChildren<Props>> */}
        <DeferredComponent {...props} />
      </Suspense>
    );

    useEffect(() => {
      const timerId = setTimeout(() => {
        setState(performance.now() - delay * 1000);
      }, delay);
      return () => clearTimeout(timerId);
    }, []);

    if (performance.now() - state < delay) {
      return <Fallback />;
    }

    return actualResult;
  };
  return DeferredComponentWrapper;
}

AsyncLoader.displayName = 'AsyncLoader';

export default AsyncLoader;
